module.exports = __webpack_public_path__ + "media/images/reseller--e908ddbf.jpg";